import {memo} from "react";
import pxToRem from "hooks/usePxToRem";

import {Stack} from "@mui/material";

import {DefaultCardStructure} from "components";
import {useFormContext} from "react-hook-form";
import {ProcessTextField} from "views/ProcessDetails/refactor/components";
import {Grid} from "@mui/system";
import {TaxesListing} from "views/ProcessDetails/refactor/components/ProcessTaxes/components";
import {Charge} from "views/ProcessDetails/refactor/types/charges.types";
import {format} from "date-fns";
import {getDateMinusTimezone} from "util/getISODate";

const ActivityOriginAgentTaxes = () => {
  const {watch} = useFormContext();
  const processCharges = watch("processCharges");
  const originAgent = watch("originAgent");

  const originAgentTaxes = processCharges?.filter(
    (item) => item?.paymentPerson?.id === originAgent?.id,
  );
  const totalPayment = originAgentTaxes
    ?.reduce((sum, item) => sum + Number(item.valuePaymentTotal), 0)
    ?.toFixed(2);

  const totalReceipt = originAgentTaxes
    ?.reduce((sum, item) => sum + Number(item.valueReceiptTotal), 0)
    ?.toFixed(2);

  const formatToDecimal = (value: number) => {
    return Number(value).toFixed(2);
  };

  const getTableData = (charges: Charge[]) => {
    const originAgent = watch("originAgent");

    const originAgentTaxes = charges.filter(
      (item) => item?.paymentPerson?.id === originAgent?.id,
    );

    const result = originAgentTaxes?.map((charge) => ({
      id: charge.id,
      idKnowledgeHouse: charge.idKnowledgeHouse,
      rate: charge.displayCharge?.name,
      equipment: charge.equipment?.name,
      displayCharge: charge.displayCharge?.name,
      originCharge: charge.originCharge,
      dateExpiry: charge.dateExpiry
        ? format(getDateMinusTimezone(charge.dateExpiry), "yyyy-MM-dd")
        : "",
      modalityPayment: charge.modalityPayment,
      payTo: charge.payTo,
      typeService: charge.typeService,
      paymentPerson: charge.paymentPerson?.name,
      paymentCurrency: charge.paymentCurrency?.abbreviation,
      typePayment: charge.typePayment,
      billingPayment: charge.billingPayment,
      quantityPayment: formatToDecimal(charge.quantityPayment),
      valuePaymentUnit: formatToDecimal(charge.valuePaymentUnit),
      valuePaymentMinimum: formatToDecimal(charge.valuePaymentMinimum),
      valuePaymentTotal: formatToDecimal(charge.valuePaymentTotal),
      valueReceiptUnit: formatToDecimal(charge.valueReceiptUnit),
      valueReceiptMinimum: formatToDecimal(charge.valueReceiptMinimum),
      valueReceiptTotal: formatToDecimal(charge.valueReceiptTotal),
      receiptPerson: charge.receiptPerson?.name,
      receiptCurrency: charge.receiptCurrency?.abbreviation,
      typeReceipt: charge.typeReceipt,
      receiveFrom: charge.receiveFrom,
      quantityReceipt: formatToDecimal(charge.quantityReceipt),
      modalityReceipt: charge.modalityReceipt,
    }));
    return result;
  };

  return (
    <DefaultCardStructure
      title="Taxas Agente de Origem"
      linkId="taxes"
      hasDivider={false}
      titleMarginBottom={5}
      sx={{mt: pxToRem(30)}}
    >
      <Stack sx={{gap: pxToRem(20)}}>
        <TaxesListing
          getTableData={getTableData}
          onRequestOpenModalComposition={() => void 0}
          setSelectedChargeId={() => void 0}
        />
      </Stack>

      <DefaultCardStructure title="Totais" hasDivider={false} isSubcard>
        <Stack direction="row" gap={pxToRem(12)}>
          <Grid size={12}>
            <ProcessTextField
              label="Pagamento total"
              disabled
              size="small"
              value={totalPayment}
            />
          </Grid>
          <Grid size={12}>
            <ProcessTextField
              label="Recebimento total"
              disabled
              size="small"
              value={totalReceipt}
            />
          </Grid>
        </Stack>
      </DefaultCardStructure>
    </DefaultCardStructure>
  );
};

export default memo(ActivityOriginAgentTaxes);
